import React, {Component} from "react";
import {inject, observer} from "mobx-react";
import "../assets/stylesheets/QrcodeScan.scss";
import Breadcrumb from "../components/Breadcrumb";
import QrReader from 'react-qr-reader';
import QrcodeStore from '../stores/QrcodeStore';
import Device from '../utils/Device'

@inject('Navigator')
@observer
export default class QrcodeScan extends Component {

    constructor(props){
        super(props);
        this.state = {
            delay: 100,
            status: 0
        };

        this.handleScan = this.handleScan.bind(this)
    }

    handleScan(data){
        // caso o scan seja diferente de null então o qrcode foi lido
        if( data !== null) {
            // seta delay de busca alto para não enviar mais de uma requisição
            this.setState({
                delay: 10000000,
                status: QrcodeStore.load
            });

            // envia url qrcode para api
            let result = this.sendQrcode(data);
            if( result) {
                this.setState({
                    status: QrcodeStore.confirm
                });
                setInterval(function () {
                    this.setState({
                        delay: 100,
                        status: 0
                    });
                    document.getElementsByClassName("confirm")[0].className = "confirm none";
                },3000);
            } else {
                this.setState({
                    status: QrcodeStore.fail
                });
                setInterval(function () {
                    this.setState({
                        delay: 100,
                        status: 0
                    });
                },3000);
            }
        }
    }

    handleError(err){
        console.error(err)
    }

    sendQrcode(url) {
        return QrcodeStore.sendQrcode(url);
    }

    static breadcrumbSegments = [
        {
            title: "Teacher's Desk",
            uri: "/"
        },
        {
            title: "QR Code Scanner",
            uri: ""
        }
    ];

    handleBreadcrumbClick(uri) {
        this.props.ConfigStore.animationType = "right";
        this.props.Navigator.replace(uri);
    }

    handleQrcodeClick() {
        // var video = document.querySelector('video');
        // video.play();
        Device.requestQrCodeScan();
    }

    componentDidMount() {
        
    }

    render() {
        const previewStyle = {
            width: 560,
            height: 560
        }

        return (
            <div className="QrcodeScan Page">
                <div className="container">
                    <div className="header-section">
                        <h1>QR Code Scanner</h1>
                        <Breadcrumb segments={QrcodeScan.breadcrumbSegments}
                                    onClick={this.handleBreadcrumbClick.bind(this)}/>
                    </div>
                    <div className="mt-30"/>
                    <div className="contents">
                        <div className="Map">
                            <div className="qr-block" onClick={this.handleQrcodeClick.bind(this)}>
                                <div className="qr-limiter"/>
                                <div className={this.state.status == QrcodeStore.fail ? "error" : "error none" }/>
                                <div className={this.state.status == QrcodeStore.confirm ? "confirm" : "confirm none" }/>
                                <div className={this.state.status == QrcodeStore.load ? "loading" : "loading none" }/>
                                {/*<QrReader*/}
                                    {/*delay={this.state.delay}*/}
                                    {/*style={previewStyle}*/}
                                    {/*facingMode="front"*/}
                                    {/*onError={this.handleError}*/}
                                    {/*onScan={this.handleScan}*/}
                                {/*/>*/}
                            </div>

                            <div className="description">
                                <div className="title">PARA REGISTRAR SUA PRESENÇA</div>
                                <div className="sub-title">
                                    Permita o acesso à câmera e
                                    <div className="mt-20"></div>
                                    escaneie o QRCode dos alunos.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )

    }

}


// WEBPACK FOOTER //
// ./src/containers/QrcodeScan.js